export default {
  de: {
    loading: "Ihr Bewertungsformular wird geladen …",
    loadingHint: "Wir laden die Angaben zu Ihrem Seminar. Bitte warten Sie einen Moment.",
    retry: "Erneut versuchen",
    support: "Support kontaktieren",
    details: "Angaben für den Support",
    code: "Fehlercode",
    time: "Zeitpunkt",
    link: "Bewertungslink",
    supportSubject: "Problem mit dem Bewertungsformular",
    supportIntro: "Guten Tag, beim Bewertungsformular ist folgendes Problem aufgetreten:",
    kept: "Ihre Eingaben bleiben in diesem geöffneten Formular erhalten. Bitte laden Sie die Seite nicht neu.",
    uncertain: "Wir haben keine verlässliche Bestätigung erhalten. Möglicherweise wurde der Vorgang bereits ausgeführt. Bitte wenden Sie sich vor einem erneuten Absenden an unseren Support.",
    newsletterOptional: "Sie können Ihre Bewertung trotzdem abgeben. Nur die Prüfung Ihrer Newsletter-Anmeldung ist derzeit nicht möglich.",
    reviewPending: "Ihre Bewertung wird gesendet …",
    newsletterPending: "Ihre Newsletter-Anmeldung wird gesendet …",
    newsletterDone: "Ihre Newsletter-Anmeldung wurde bereits übermittelt und wird nicht erneut gesendet.",
    operations: {
      load: "Bewertungsformular laden",
      review: "Bewertung senden",
      newsletter: "Newsletter-Anmeldung senden",
      newsletterCheck: "Newsletter-Status prüfen",
    },
    offline: {
      title: "Keine Internetverbindung",
      message: "Ihr Browser meldet, dass Sie offline sind. Prüfen Sie Ihre Internetverbindung und versuchen Sie es danach erneut.",
    },
    connection: {
      title: "Verbindung nicht möglich",
      message: "Die Verbindung zu unserem Bewertungsdienst konnte nicht hergestellt werden. Prüfen Sie Ihre Internetverbindung oder versuchen Sie es später erneut.",
    },
    timeout: {
      title: "Der Server antwortet nicht rechtzeitig",
      message: "Die Antwort hat zu lange gedauert. Bitte versuchen Sie es in einigen Minuten erneut.",
    },
    notFound: {
      title: "Buchung nicht gefunden",
      message: "Zu dieser Anfrage konnte keine Buchung gefunden werden. Öffnen Sie bitte den vollständigen Bewertungslink aus unserer E-Mail. Falls das nicht hilft, kontaktieren Sie unseren Support.",
    },
    access: {
      title: "Zugriff derzeit nicht möglich",
      message: "Unser Bewertungsdienst konnte die Anfrage nicht freigeben. Sie müssen sich nicht anmelden. Versuchen Sie es später erneut oder kontaktieren Sie unseren Support.",
    },
    rateLimit: {
      title: "Zu viele Anfragen",
      message: "Der Dienst hat vorübergehend zu viele Anfragen erhalten. Warten Sie bitte einige Minuten, bevor Sie es erneut versuchen.",
    },
    server: {
      title: "Unser Bewertungsdienst ist vorübergehend gestört",
      message: "Bei der Verarbeitung ist ein Serverfehler aufgetreten. Bitte versuchen Sie es später erneut. Wenn das Problem bestehen bleibt, kontaktieren Sie unseren Support.",
    },
    conflict: {
      title: "Änderung nicht möglich",
      message: "Der Server hat die Änderung abgelehnt. Eine bereits veröffentlichte Bewertung kann zum Beispiel nicht mehr geändert werden. Unser Support hilft Ihnen weiter.",
    },
    validation: {
      title: "Angaben konnten nicht verarbeitet werden",
      message: "Bitte prüfen Sie Ihre Angaben. Falls sie korrekt sind und der Fehler erneut auftritt, kontaktieren Sie unseren Support.",
    },
    invalidResponse: {
      title: "Unvollständige Serverantwort",
      message: "Unser Dienst hat keine verwendbare Bestätigung oder unvollständige Seminardaten geliefert. Bitte kontaktieren Sie unseren Support.",
    },
    unknown: {
      title: "Unerwarteter Fehler",
      message: "Der Vorgang konnte nicht abgeschlossen werden. Bitte kontaktieren Sie unseren Support und geben Sie den unten stehenden Fehlercode an.",
    },
  },
  en: {
    loading: "Loading your evaluation form …",
    loadingHint: "We are loading your seminar details. Please wait a moment.",
    retry: "Try again",
    support: "Contact support",
    details: "Support information",
    code: "Error code",
    time: "Time",
    link: "Evaluation link",
    supportSubject: "Problem with the evaluation form",
    supportIntro: "Hello, I encountered the following problem with the evaluation form:",
    kept: "Your entries are kept in this open form. Please do not reload the page.",
    uncertain: "We did not receive a reliable confirmation. The request may already have been processed. Please contact support before submitting again.",
    newsletterOptional: "You can still submit your evaluation. Only the newsletter status check is currently unavailable.",
    reviewPending: "Sending your evaluation …",
    newsletterPending: "Sending your newsletter subscription …",
    newsletterDone: "Your newsletter subscription has already been submitted and will not be sent again.",
    operations: {
      load: "Load evaluation form",
      review: "Send evaluation",
      newsletter: "Send newsletter subscription",
      newsletterCheck: "Check newsletter status",
    },
    offline: {
      title: "No internet connection",
      message: "Your browser reports that you are offline. Check your internet connection, then try again.",
    },
    connection: {
      title: "Unable to connect",
      message: "We could not connect to the evaluation service. Check your internet connection or try again later.",
    },
    timeout: {
      title: "The server did not respond in time",
      message: "The response took too long. Please try again in a few minutes.",
    },
    notFound: {
      title: "Booking not found",
      message: "No booking could be found for this request. Please open the complete evaluation link from our email. If that does not help, contact support.",
    },
    access: {
      title: "Access is currently unavailable",
      message: "Our evaluation service could not authorize the request. You do not need to log in. Please try again later or contact support.",
    },
    rateLimit: {
      title: "Too many requests",
      message: "The service has temporarily received too many requests. Please wait a few minutes before trying again.",
    },
    server: {
      title: "Our evaluation service is temporarily unavailable",
      message: "A server error occurred while processing the request. Please try again later. If the problem persists, contact support.",
    },
    conflict: {
      title: "This change is not possible",
      message: "The server rejected the change. For example, an evaluation that has already been published can no longer be changed. Please contact support for help.",
    },
    validation: {
      title: "Your entries could not be processed",
      message: "Please check your entries. If they are correct and the error persists, contact support.",
    },
    invalidResponse: {
      title: "Incomplete server response",
      message: "Our service returned an unusable confirmation or incomplete seminar details. Please contact support.",
    },
    unknown: {
      title: "Unexpected error",
      message: "The request could not be completed. Please contact support and include the error code below.",
    },
  },
};
